import floatingSidebar from '../global/floating-sidebar';

floatingSidebar('js_sidebarContainer', 'js_floatingSidebar', 'oraOfferSidebar--floating', 'oraOfferSidebar--fixToBottom');
